import App from './App.svelte';
import gsap from 'gsap';
import MotionPathPlugin from "gsap/MotionPathPlugin";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";

// Register gsap plugins here
gsap.registerPlugin(MorphSVGPlugin);
gsap.registerPlugin(MotionPathPlugin);

const app = new App({
	target: document.body
});

export default app;